/* eslint-disable no-alert */
import React, { PureComponent } from 'react'
import geolib from 'geolib'
import { connect } from 'react-redux'
import { Input, Menu, Label, Icon, Grid, Button, Modal } from 'semantic-ui-react'
import firebase from 'firebase/app'

import get from 'lodash/get'
import find from 'lodash/find'
import size from 'lodash/size'
import filter from 'lodash/filter'
import reduce from 'lodash/reduce'

class ModalAssignDriver extends PureComponent {
  state = {
    selectedDriver: null,
    assigning: false,
    searchValue: '',
  }

  componentWillReceiveProps(nextProps) {
    const { order } = this.props
    const allOrders = (nextProps.todayOrders && nextProps.todayOrders.all) || []

    if (order) {
      const { action } = nextProps
      const nextOrder = find(allOrders, ({ key }) => key === order.key)

      if (nextOrder && order !== nextOrder) {
        if (
          (action === 'reserve' && nextOrder.reserve_driver) ||
          (action !== 'reserve' && nextOrder.driver_pending_order)
        ) {
          this.setState({ assigning: false }, this.onModalClose)
        }
      }
    }
  }

  getStatusColor = status => {
    switch (status) {
      case 'busy':
        return 'red'
      case 'available':
        return 'green'
      case 'waiting_for_confirm':
        return 'yellow'
      default:
        return 'gray'
    }
  }

  handleAssignDriver = async () => {
    try {
      const { selectedDriver } = this.state
      const { order, queueOrders, isExpressOrder } = this.props

      this.setState({ assigning: true })

      const params = {
        actionType: isExpressOrder ? 'assign-express-driver' : 'assign-driver',
        orderUid: order.key || order.id,
        driverUid: selectedDriver,
        refind: order.status === 'drivers_not_available',
        queueOrderUids: queueOrders && queueOrders.map(o => o.key || o.id),
      }

      const callableName = isExpressOrder ? 'expressAction' : 'orderAction'

      const functions = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable(callableName)

      await functions(params)

      this.setState({ assigning: false }, this.onModalClose)
    } catch (error) {
      this.setState({ assigning: false })
      alert(error.message || error)
    }
  }

  handleSwitchDriver = async () => {
    try {
      const { selectedDriver } = this.state
      const { order, queueOrders } = this.props

      this.setState({ assigning: true })

      const params = {
        orderUid: order.key,
        targetDriverUid: selectedDriver,
        driverUid: order.deliverer,
        switchType: 'manual',
        queueOrderUids: queueOrders,
      }

      const functions = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable('orderAction')

      await functions({ actionType: 'switch-driver', ...params })

      this.setState({ assigning: false }, this.onModalClose)
    } catch (error) {
      this.setState({ assigning: false })
      alert(error.message || error)
    }
  }

  handleReserveDriver = async () => {
    try {
      const { selectedDriver } = this.state
      const { order } = this.props

      this.setState({ assigning: true })

      const params = {
        orderUid: order.key,
        driverUid: selectedDriver,
      }

      const functions = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable('orderAction')

      await functions({ actionType: 'reserve-driver', ...params })

      this.setState({ assigning: false }, this.onModalClose)
    } catch (error) {
      this.setState({ assigning: false })
      alert(error.message || error)
    }
  }

  handleOnAssignClick = () => {
    const { action } = this.props
    let questionType = 'reserve'

    questionType = action === 'manual' ? 'assign' : 'switch driver from'

    const conf = window.confirm(`Are you sure to ${questionType} the order to selected driver?`)

    if (conf) {
      if (action === 'manual') {
        this.handleAssignDriver()
      } else if (action === 'switch') {
        this.handleSwitchDriver()
      } else if (action === 'reserve') {
        this.handleReserveDriver()
      }
    }
  }

  getAvailableDriversByDistance = () => {
    const { order, action } = this.props
    const { allDrivers, isExpressOrder } = this.props

    const driversCoords = reduce(
      allDrivers,
      (result, driver, driverUid) => {
        const isOnline = driver.online && driver.location
        const isAvailable = driver.status === 'available'
        const isReservable = action === 'reserve'
        const isSwitchable = action === 'manual' || action === 'switch'

        if (isOnline && (isReservable || (isSwitchable && isAvailable))) {
          // eslint-disable-next-line no-param-reassign
          result[driverUid] = {
            latitude: driver.location.latitude,
            longitude: driver.location.longitude,
          }
          return result
        }

        return result
      },
      {}
    )

    if (!order) return {}

    let origin = {}

    if (isExpressOrder)
      origin = get(order, 'pickup_location', {})
    else {
      const merchantLocation = get(order, 'etaInfo.info.legs.0.start_location', {})

      origin = {
        latitude: merchantLocation.lat,
        longitude: merchantLocation.lng,
      }
    }

    return geolib.orderByDistance(origin, driversCoords)
  }

  onModalClose = () => {
    const { onCancel } = this.props

    this.setState({ selectedDriver: null, searchValue: '' }, onCancel)
  }

  onSearchChange = e => this.setState({ searchValue: e.target.value.toLowerCase().trim() })

  handleOnDriverClick = driverUID => {
    const { selectedDriver } = this.state

    if (driverUID === selectedDriver) {
      this.setState({ selectedDriver: null })
    } else {
      this.setState({ selectedDriver: driverUID })
    }
  }

  handleFitterDriverBySearch = drivers => {
    const { allDrivers } = this.props
    const { searchValue } = this.state

    return filter(drivers, ({ key: driverUid }) => {
      const driver = allDrivers[driverUid]

      const searchNameValue = `${driver.family_name} ${driver.first_name}`.toLowerCase()
      const searchTelValue = driver.tel.toLowerCase()

      return searchNameValue.indexOf(searchValue) !== -1 || searchTelValue.indexOf(searchValue) !== -1
    }).map((driver, index) => {
      return this.renderDriverRow(driver.key, driver.distance, index)
    })
  }

  renderDriverRow = (driverUid, distance, index) => {
    const { allDrivers } = this.props
    const { selectedDriver } = this.state
    const driverData = allDrivers[driverUid]

    const distanceInKm = `${parseFloat(distance / 1000).toFixed(2)} km`

    return (
      <Menu.Item
        key={index + 1}
        active={selectedDriver === driverUid}
        style={{ padding: '13px 10px', borderRadius: 0 }}
        onClick={() => this.handleOnDriverClick(driverUid)}
      >
        <div style={{ flexDirection: 'row', alignItems: 'center', display: 'flex' }}>
          <Label
            size="large"
            style={{ marginRight: 5, justifyContent: 'center', width: 60, display: 'flex' }}
          >
            <Icon name="box" />
            {driverData.package_size && driverData.package_size.substring(0, 1).toUpperCase()}
          </Label>
          <Label
            size="large"
            style={{ marginRight: 5, width: 120, justifyContent: 'center', display: 'flex' }}
          >
            {driverUid}
          </Label>
          <div style={{ display: 'flex', marginRight: 5 }}>
            {driverData.status && <Label circular color={this.getStatusColor(driverData.status)} empty />}
          </div>
          <div
            style={{
              flex: 1,
              fontSize: 15,
              display: 'flex',
              lineHeight: '1.3',
              whiteSpace: 'normal',
              wordBreak: 'break-all',
            }}
          >
            {`${index + 1}. ${driverData.family_name} ${driverData.first_name}`}
          </div>
          <Label
            size="large"
            style={{ marginLeft: 5, width: 100, justifyContent: 'center', display: 'flex' }}
          >
            {distanceInKm}
          </Label>
          {selectedDriver === driverUid && (
            <div style={{ display: 'flex', width: 20, justifyContent: 'flex-end', marginLeft: 5 }}>
              <Icon name="check" color="green" />
            </div>
          )}
        </div>
      </Menu.Item>
    )
  }

  renderDriverList = () => {
    const drivers = this.getAvailableDriversByDistance()
    let driverList = []

    if (size(drivers) > 0) {
      driverList = this.handleFitterDriverBySearch(drivers)
    }

    return (
      <Menu
        fluid
        vertical
        style={{ height: 'calc(60vh - 20px)', maxHeight: 'calc(60vh - 20px)', overflow: 'auto' }}
      >
        <Menu.Item key="header" header style={{ padding: 10 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ display: 'flex', flex: 1 }}>List of Drivers</div>
            <div style={{ display: 'flex' }}>
              <Input
                type="text"
                icon="search"
                placeholder="Search"
                name="search-driver"
                onChange={this.onSearchChange}
                style={{ height: 30, width: 200 }}
              />
            </div>
          </div>
        </Menu.Item>

        {size(driverList) > 0 ? (
          driverList
        ) : (
          <Menu.Item key="no-results" style={{ padding: '13px 10px', borderRadius: 0 }}>
            No results
          </Menu.Item>
        )}
      </Menu>
    )
  }

  render() {
    const { visible, action } = this.props
    const { assigning, selectedDriver } = this.state

    let label = 'Reserve Driver'
    let buttonLabel = 'Reserve'

    if (action === 'manual') {
      label = 'Assign Driver'
      buttonLabel = 'Assign'
    } else if (action === 'switch') {
      label = 'Switch Driver'
      buttonLabel = 'Switch'
    }

    return (
      <Modal
        open={visible}
        style={{ marginTop: 0, width: 600 }}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header>{label}</Modal.Header>
        <Modal.Content style={{ padding: 0 }}>
          <Grid columns="equal" style={{ margin: 0 }}>
            <Grid.Row style={{ padding: 0 }}>
              <Grid.Column style={{ padding: 10 }}>{this.renderDriverList()}</Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button negative disabled={assigning} onClick={() => this.onModalClose()}>
            Cancel
          </Button>
          <Button
            secondary
            loading={assigning}
            content={buttonLabel}
            onClick={() => this.handleOnAssignClick()}
            disabled={selectedDriver === null || assigning}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapState = ({ orders, drivers }) => ({
  allDrivers: drivers.drivers,
  todayOrders: orders.todayOrders,
})

export default connect(mapState)(ModalAssignDriver)



// WEBPACK FOOTER //
// ./src/components/orders/ModalAssignDriver.js